import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { deleteMspDattoIntegrationSuccess } from '../credentials/actions';
import * as actions from './actions';
import { MspDattoMapping } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspDattoMappings';

export interface State extends EntityState<MspDattoMapping>, Status {}

export const adapter = createEntityAdapter<MspDattoMapping>({
    selectId: (item) => item.tenantId,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadMspDattoMappings, (state) => ({ ...state, loading: true })),
    on(actions.loadMspDattoMappingsSuccess, (state, action) =>
        adapter.setAll(action.items, { ...state, loaded: true, loading: false }),
    ),

    on(actions.loadMspDattoMappingsFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(actions.updateMspDattoMappings, (state) => ({ ...state, updating: true })),
    on(actions.updateMspDattoMappingsSuccess, (state, action) =>
        adapter.setAll(action.items, { ...state, updating: false, loaded: true }),
    ),
    on(actions.updateMspDattoMappingsFailure, (state, { error }) => ({ ...state, error, updating: false })),
    on(deleteMspDattoIntegrationSuccess, () => initialState),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
